<template>
  <div class="clearfix">
    <a-upload
      action="/merchant.php/upload_file/uploadFile?type=ATTRIBUTE"
      list-type="picture-card"
      :before-upload="beforeUpload"
      :file-list="fileList"
      multiple
      @preview="handlePreview"
      @change="handleChange"
    >
      <div v-if="!(limit && fileList.length < limit)">
        <a-icon type="plus" />
        <div class="ant-upload-text">
          上传
        </div>
      </div>
    </a-upload>
    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="handleCancel"
    >
      <img
        alt="example"
        style="width: 100%; margin-top:30px"
        :src="previewImage"
      />
    </a-modal>
  </div>
</template>

<script>

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}
function formatFileList (val) {
  const arr = []
  val.forEach((item, index) => {
    const urlArr = item.split('/')
    const name = urlArr[urlArr.length - 1]
    arr.push({
      uid: -index,
      url: item,
      name: name // 文件名
    })
  })
  return arr
}

export default {
  data() {
    return {
      previewVisible: false,
      previewImage: '',
      fileList: formatFileList(this.value),
      timer: null,
      status: 'done', // 是否有图片上传
      upFileList: [],
      fileInitNum: -1
    }
  },
  props: {
    // 最多可上传图片数，默认不限制
    limit: {
      type: Number,
      default: 0
    },
    // 值
    value: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    value(val) {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        if (this.status !== 'uploading') {
          this.fileList = formatFileList(val)
          this.uploadSort('init')
        }
      }, 500)
    }
  },
  methods: {
    handleCancel() {
      this.previewVisible = false
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    handleChange({ file, fileList }) {
      this.status = file.status
      fileList.map((item, i) => {
        if (!item.uid) {
          item.uid = -i
        }
      })
      if (file.status) {
        this.fileList = fileList
      }
      var v = Object.assign([], this.value)
      if (file.status === 'done') {
        if (file.response.code === 200) {
          const url = file.response.data.url
          v.push(url)
          var fileArr = this.uploadSort('sort', file, fileList, v)
          this.fileList = fileArr.fileList
          v = fileArr.val
          this.$emit('input', v)
        } else {
          this.$message.error('图片上传失败!')
          this.$emit('input', v)
        }
      }
      if (file.status === 'error') {
        this.$emit('input', v)
        this.$message.error('图片上传失败!')
      }
      if (file.status === 'removed') {
        const index = v.indexOf(file.url)
        v.splice(index, 1)
        this.$emit('input', v)
      }
    },
    // 上传图片前
    beforeUpload(file) {
      this.uploadSort('ready', file)
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp'
      if (!isJpgOrPng) {
        this.$message.error('只能上传jpg、png、bmp格式的图片!')
        return false
      }
      const maxSize = 5 * 1024 * 1024
      if (file.size > maxSize) {
        this.$message.error('图片大小不能超过5MB!')
        return false
      } else if (file.size > (2 * 1024 * 1024)) {
        return new Promise((resolve, reject) => {
          this.transformFile(file).then(res => {
            resolve(res)
          }).catch(error => {
            reject(error)
          })
        })
      } else {
        return true
      }
    },
    // 压缩转换上传的文件
    transformFile(file, maxSize = 2 * 1024 * 1024) {
      // const maxSize = 2 * 1024 * 1024
      return new Promise(resolve => {
        // 压缩
        // 先new一个img和fileReader的实例
        const img = new Image()
        const reader = new FileReader() // 读取文件资源
        reader.readAsDataURL(file)
        reader.onload = (e) => {
          img.src = e.target.result
          img.onload = () => {
            // 转化后的img元素后，先取出该元素的宽高度
            const { width, height } = img
            // 创建画布
            const canvas = document.createElement('canvas')
            const context = canvas.getContext('2d')
            // 设置宽高度为等同于要压缩图片的尺寸
            canvas.width = width
            canvas.height = height
            context.clearRect(0, 0, width, height)
            // 将img绘制到画布上
            context.drawImage(img, 0, 0, width, height)
            let cropImg = canvas.toDataURL('image/jpeg', 1.0)
            if (file.size > maxSize) {
              cropImg = canvas.toDataURL('image/jpeg', maxSize / file.size)
            }
            resolve(this.dataURLtoFile(cropImg, file.name))
          }
        }
      })
    },
    /**
     * @author varnew
     * @params: dataurl: base64地址;filename: 希望转成的图片格式如“png”
     */
    dataURLtoFile(dataurl, filename) {
      // 将base64转换为文件
      // console.log(dataurl)
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      // ！！！IE、Safari不支持使用new File()，File继承于Blob，绝大多数场景下，使用Blob对象就可以了
      return new File([u8arr], filename, { type: mime })
      // console.log(new Blob([u8arr], { type: mime }))
      // Blob 无法设置filename
      // const blob = new Blob([u8arr], { type: mime })
      // const file = new File([blob], new Date().getTime() + '.png')
      // return file
    },
    // 解决图片上传时顺序错乱
    uploadSort(type, file = '', fileData = [], val = []) {
      // ready 在图片上传前，将顺序保存起来（以图片名为标识） 并记录原有的数量
      // sort 将图片数组截剩新增图片，再按照保存的顺序保存到新的数组，返回总的图片数组 （主要是要改变val的排序，fileData只是做一个标识）
      // init 初始化零时属性的值
      switch (type) {
        case 'ready':
          this.upFileList.push(file.name)
          if (this.fileInitNum === -1) {
            this.fileInitNum = this.fileList.length
          }
          break
        case 'sort':
          var uFList = this.upFileList
          var FInit = this.fileInitNum
          let newValArr = val.splice(0, FInit)
          let newListArr = fileData.splice(0, FInit)
          if (val.length > 1 && uFList.length === val.length) {
            // 当添加的图片大于2张，且添加到最后一张的时候再做排序
            for (var item of uFList) {
              for (var i = 0; i < fileData.length; i++) {
                if (item === fileData[i].name) {
                  newValArr.push(fileData[i].response.data.url)
                  newListArr.push(fileData[i])
                }
              }
            }
          } else {
            // 不做处理的时候还原数组
            newListArr = newListArr.concat(fileData)
            newValArr = newValArr.concat(val)
          }
          return { 'fileList': newListArr, 'val': newValArr }
        case 'init':
          this.upFileList = []
          this.fileInitNum = -1
      }
    }
  }
}
</script>

<style>
/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.ant-upload.ant-upload-select-picture-card {
    width: 104px;
    height: 104px;
}
</style>
